
import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";
import { StudentAssignmentListingModel } from "common/models/page-models/Student Assignment/student-assignment-grid-model";
import { StudentAssignmentModel } from "common/models/page-models/Student Assignment/student-assignment-data.model";



@Injectable()
export class StudentToDoAssignmentDetailsDataService extends DataService<StudentAssignmentModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.StudentToDoAssignmentDetails,http);
    }
    
    createInstance():StudentAssignmentModel  {
        return new StudentAssignmentModel();
    }

    

}

